import { createBrowserId } from "@/lib/browserId";

export const SESSION_STORAGE_KEY = "vs_session_id";
export const AI_SESSION_HEADER = "x-vs-session-id";

export const getSessionId = (): string => {
  const nextId = () => createBrowserId();

  try {
    if (typeof window === "undefined" || !window.sessionStorage) return nextId();

    const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (existing) return existing;

    const sid = nextId();
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, sid);
    return sid;
  } catch {
    return nextId();
  }
};

export const aiFunctionHeaders = (): Record<typeof AI_SESSION_HEADER, string> => ({
  [AI_SESSION_HEADER]: getSessionId(),
});
